module.exports = __webpack_public_path__ + "static/media/14UNEP15.d32ed84a.jpg";